import i18next from 'i18next'
import React from 'react'
import { ImageOptions } from '../../utils/image'
import { Alphabetized } from '../azNavigation/azNavigationUtils'
import { SpecialistProps } from '../cmsPage/blocks/block/specialistsBlock/specialistsBlockLayout'
import { EmptyLayout } from '../sharedLayout/empty'
import { GenericPageHeader } from '../sharedLayout/pageheader'
import { NavigationSection } from '../sharedLayout/navigationSection'

export const SpecialistOverviewHeaderLayout = (props: {
  department?: string
  breadcrumbs: { title: string; url: string }[]
}) => (
  <GenericPageHeader
    kind="specialistOverview"
    breadcrumbs={props.breadcrumbs}
    title={
      props.department
        ? `${i18next.t('misc:specialist_plural')} - ${props.department}`
        : i18next.t('misc:specialist_plural')
    }
  />
)

export const SpecialistOverviewSectionLayout = (props: {
  specialists: Alphabetized<SpecialistProps>
  imageOptions: ImageOptions
}) => (
  <section className="sections sections--pagination sections--specialists container--m gutter--m">
    {props.specialists.length > 0 ? (
      props.specialists.map((section) => (
        <NavigationSection
          key={section.letter}
          kind="specialist"
          letter={section.letter}
          specialists={section.items}
          imageOptions={props.imageOptions}
        />
      ))
    ) : (
      <EmptyLayout
        hasWrapper={false}
        text={i18next.t('a11y:noEntityFound', {
          entity: i18next.t('misc:specialist_plural').toLowerCase(),
        })}
      />
    )}
  </section>
)
